<template>
	<div id="reg" class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<FormulateForm
			v-else-if="mounted && autocompleted"
			v-model="formValues"
			class="row"
			:form-errors="formErrors"
			@submit="sendData($event)"
			@validatePhone="validatePhone"
		>
			<div class="col-12 col-lg data-block">
				<h4 class="title mb-3">
					Основная информация
				</h4>
				<div class="row">
					<FormulateSchema
						:schema="schema"
						v-on="schemaListeners"
						@setCompanyInfo="setCompanyInfo"
					/>
				</div>
				<div
					v-if="(isAuthorized && block.authentication_required)
						|| !block.authentication_required"
					class="row order-10"
				>
					<div class="col-12">
						<div v-html="block.footer_text" />
					</div>
					<div class="col-12">
						<div v-if="!block.hide_promo_code_field" class="mb-4">
							<label class="mb-2" for="promocode">Промокод</label>
							<div
								class="formulate-promocode"
								:class="isActivatePromocode ? 'formulate-promocode--active' : ''"
							>
								<FormulateInput
									v-if="!isActivatePromocode"
									id="promocode"
									v-model.trim="promocode"
									type="text"
									name="promo"
									placeholder="Промокод"
									class="px-0 mb-0 mr-2 promocode-input col"
								/>
								<div v-else class="formulate-promocode--active__text px-0 col">
									Промокод применен
								</div>
								<div
									v-if="promocode.length > 0 && !isActivatePromocode"
									@click="checkPromocodeLanding"
								>
									<icon-arrow-right
										class="arrow-right--black"
									/>
								</div>
								<div
									v-else-if="isActivatePromocode"
									class="close"
									@click="resetPromocode"
								/>
							</div>
							<div
								class="formulate-promocode__error"
							>
								{{ promocodeMessage }}
							</div>
						</div>
					</div>
				</div>
				<div v-else class="row">
					<div class="col-12 mb-3">
						Необходимо быть зарегистрированным в системе
					</div>
					<FormulateInput
						type="button"
						class="mb-0 col-12"
						:disabled="isLoadingSubmit"
						@click="showLoginPopup"
					>
						Авторизоваться
					</FormulateInput>
				</div>
			</div>
			<div class="col-12 col-lg-6 pl-lg-4">
				<h4 class="title mb-3">
					Выбор билетов
				</h4>
				<div
					v-if="!studyStatusCheck"
				>
					<FormulateInput
						v-if="isFoundationDayForm && !isVerifyAlumni"
						class="col-12 px-0 mb-3 small"
						type="CustomSwitch"
						name="needVerifyAlumni"
						label-text="Я получаю диплом в этот день"
						data-action="panels-need-verify-alumni"
						validation="minOneAdult"
						:validation-rules="{
							minOneAdult: () => !isDiplomaError
						}"
						error-behavior="live"
						:validation-messages="{
							minOneAdult: 'Выберите минимум один взрослый билет'
						}"
						@input="handlerDiplomaChange"
					/>
				</div>
				<div v-if="allProductsFromGroup" class="order-0">
					<div class="row">
						<div class="col-12">
							<products-component
								v-model="products"
								:block="block"
								@handlerChange="handlerChange"
								@handlerChangeChildsAge="handlerChangeChildsAge"
							/>
						</div>
					</div>
				</div>

				<div v-if="isShowDonationBlock">
					<h4 class="title mb-3">
						Поддержать благотворительные фонды
					</h4>
					<div class="mb-3">
						Сделайте дополнительный взнос в пользу подопечных фондов-партнеров мероприятия
						<a
							v-if="isFoundationDayForm"
							href="javascript:void(null);"
							class="donate-info icon-info ml-1"
							aria-label="Дополнительная информация"
							title="Подробнее"
							@click="$bvModal.show('modal-donate-info')"
						/>
					</div>
					<b-modal
						id="modal-donate-info"
						button-size="sm"
						footer-class="d-none"
						size="md"
						:centered="true"
						:ok-disabled="true"
						:hide-header-close="false"
						:scrollable="true"
					>
						<p>
							Дорогие друзья, <br>
							У вас есть возможность сделать День Основания Школы по-настоящему особенным, внеся дополнительный вклад в грантовый фонд СКОЛКОВО, и войти в Клуб Благотворителей Школы. Любая сумма является значимой, так как умножается на число участников нашего Сообщества.
						</p>
						<p>За 18 лет в комьюнити Школы собралось уже около 50 000 выпускников и друзей. Даже дополнительные 1000 рублей от каждого из вас создадут фонд в 50 миллионов рублей, который позволит выдать грант талантливым абитуриентам СКОЛКОВО.</p>
					</b-modal>
					<div
						class="mb-4 btn-panel"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<button
									type="button"
									class="btn btn-outline-primary mb-2"
									:class="{
										active: amountButtonStates[5000],
									}"
									@click="setAmount(5000)"
								>
									5 000 &#8381;
								</button>
								<button
									type="button"
									class="btn btn-outline-primary mb-2"
									:class="{
										active: amountButtonStates[10000],
									}"
									@click="setAmount(10000)"
								>
									10 000 &#8381;
								</button>
								<button
									type="button"
									class="btn btn-outline-primary mb-2"
									:class="{
										active: amountButtonStates[50000],
									}"
									@click="setAmount(50000)"
								>
									50 000 &#8381;
								</button>
							</div>
							<div>
								<div
									v-if="donationAmount"
									class="close"
									@click="deleteDonation"
								/>
							</div>
						</div>
						<input
							v-model="donationAmount"
							data-msg="Пожалуйста, укажите сумму"
							name="donationAmount"
							:placeholder="$t('otherSum')"
							type="text"
							class="graduation-scenario__donation-input form-control rounded-0 required mt-2"
							@input="onAmountInput()"
						>
						<div v-if="isShowDonationErrors" class="graduation-scenario__donation-input-errors">
							{{ donationError }}
						</div>
					</div>
				</div>
				<div v-if="block.show_amount" class="amount_block mb-2">
					<p
						v-if="discountValue != 0"
						class="mb-0 d-flex justify-content-between flex-row"
					>
						<span class="strong mb-1">Итого:</span>
						<span class="strong mb-1">{{ createMaskAmount(productsSum) }} &#8381;</span>
					</p>
					<p
						v-if="discountValue != 0"
						class="mb-0 d-flex justify-content-between flex-row text-danger"
					>
						<span class="strong mb-1">Скидка:</span>
						<span class="strong mb-1">{{ createMaskAmount(discountValue) }} &#8381;</span>
					</p>
					<p class="mb-0 mt-3 d-flex justify-content-between flex-row">
						<span class="title mb-1">К оплате:</span>
						<span class="title mb-1 text-right">
							{{ totalSum }}
						</span>
					</p>
				</div>
				<points-window
					v-else-if="(isBlockContainsLoyaltyEarnProduct || isBlockContainsLoyaltyChargeProduct) && !formValues.needVerifyAlumni"
					:fetched-data="fetchedData"
					:block="block"
					:card-background="cardBackground"
					:final-price="productsSum"
					:loyalty-data="loyaltyData"
					:loyalty-profile="loyaltyProfile"
					:original-price="productsSumWithDiscount"
					:is-promo-code-used="isActivatePromocode"
					:products="products"
					:show-default-block="true"
					@setLoyaltyData="setLoyaltyData"
				/>
				<div
					class="mb-4"
				>
					<FormulateInput
						class="col-12 px-0 mb-3 small"
						type="checkbox"
						name="personalData"
						validation="required"
						:validation-messages="{
							required: `${$t('agreementRequired')}`
						}"
						data-action="personal-data-offer-agreement"
					>
						<template #label>
							<label class="ml-2">
								Отправляя форму, я даю
								<a href="https://www.skolkovo.ru/static/personaldata_rus.html" target="_blank">
									согласие на обработку моих персональных данных
								</a> и принимаю
								<a href="/pdf/den-osnovaniya-2024-contract.pdf" target="_blank">
									условия договора публичной оферты
								</a>
							</label>
						</template>
					</FormulateInput>
					<advertising-mailings-input />
				</div>
				<div>
					<FormulateErrors class="custom-form-error text-right" />
					<FormulateInput
						type="submit"
						class="mt-2 text-right"
						:disabled="isLoadingSubmit"
					>
						<b-spinner
							v-if="isLoadingSubmit"
							style="margin-right: 15px; width: 1.3em; height: 1.3em;"
						/>
						{{ isLoadingSubmit ? 'Идет отправка формы...' : submitBtnText }}
					</FormulateInput>
					<CookieError v-if="isErrorCookie" />
				</div>
			</div>
		</FormulateForm>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import moment from '@/utils/moment';
import PublicOfferAgreementInput from '~/components/panels/formulate/products/components/PublicOfferAgreementInput.vue';
import PointsWindow from '~/components/formulate/loyalty/PointsWindow.vue';
import {
	LOYALTY_LEVELS,
	FORMULATE_ORDER_STATUSES,
	ORDER_TYPES,
	ORDER_TYPE,
	STUDY_STATUSES,
} from '~/utils/dictionaries';
import debounce from 'lodash/debounce';

const MAX_DONATION_AMOUNT = 400000;
export default {
	components: {
		PointsWindow,
		LoyaltyRegistrationInput,
		AgreementInput,
		ProductsComponent,
		AdvertisingMailingsInput,
		CookieError,
		b2bAlumniInput,
		PublicOfferAgreementInput,
	},
	mixins: [formulateFormScenario],
	data() {
		return {
			productsSumWithDiscount: 0,
			productsSum: 0,
			discountValue: 0,
			productsCount: [],
			loyaltyData: null,
			userExists: false,
			needRegistration: false,
			userCheckPassed: false,
			email: null,
			isAdultTicketSelected: true,
			levels: LOYALTY_LEVELS,
			loyaltyProfile: {},
			cardBackground: null,
			studyStatus: null,
			statuses: FORMULATE_ORDER_STATUSES,
			STUDY_STATUSES,
			types: ORDER_TYPES,
			ORDER_TYPE,
			amountButtonStates: {
				50000: false,
				5000: false,
				10000: false,
			},
			donationAmount: null,
			selectedDonationProducts: [],
			isShowDonationErrors: false,
			donationError: '',
			isDiplomaError: false,
			isVerifyAlumni: false,
			formErrors: [],
		};
	},
	computed: {
		/* Стандартные события Formulate из FormulateForm */
		schemaListeners() {
			const { submit, ...listeners } = this.$listeners;
			return listeners;
		},
		studyStatusCheck() {
			const program = this.studyStatus?.formulate_products
				.some((el) => el.study_status === STUDY_STATUSES.STUDY_STATUS_ALUMNI_THIS_YEAR);
			return !!program;
		},
		isAlumni() {
			return this.$store.getters['profile/isAlumni'];
		},
		finalPrice() {
			if (!this.priceWithPromocode) {
				if (this.discountPrice > 0 && this.discount) return this.discountPrice;
				return this.can_return_vat_selected
					? this.priceWithoutVat
					: this.amount;
			}

			return this.priceWithPromocode;
		},
		originalPrice() {
			return this.can_return_vat_selected
				? this.priceWithoutVat
				: this.amount;
		},
		priceWithoutVat() {
			return this.allProductsByType.reduce(
				(sum, product) => parseFloat(sum) + parseFloat(product?.price_without_vat ?? 0),
				0,
			);
		},
		submitBtnText() {
			const registration = this.fetchedData.id === 26115 ? 'Купить билет' : 'Зарегистрироваться';
			return this.productsSumWithDiscount
				? 'Перейти к оплате'
				: registration;
		},
		productsCountSum() {
			return this.productsCount.reduce(
				(sum, product) => parseFloat(sum) + parseFloat(product?.quantity ?? 0),
				0,
			);
		},
		totalSum() {
			if ((this.productsSumWithDiscount && this.productsCountSum > 0) || this.donationAmount) {
				return `${this.createMaskAmount(this.productsSumWithDiscount)} ₽`;
			}

			if (!this.productsSumWithDiscount && this.productsCountSum) {
				return 'Бесплатно';
			}
			return 'Необходимо выбрать билет';
		},
		// Отображение для Дня основания
		isFoundationDayForm() {
			return this.block.id === 35905745;
		},
		isShowDonationBlock() {
			return this.block.donation_products.length > 0;
		},
	},
	watch: {
		'$auth.user': {
			handler(user) {
				if (user) {
					this.handlerChange(this.selectedProducts);
				}
			},
		},
		'formValues.email': {
			handler: debounce(async function (value) {
				await this.handlerChange(this.selectedProducts);
			}, 500),
		},
		isActivatePromocode: {
			handler(value) {
				if (value) {
					this.productsSum = null;
					this.productsSumWithDiscount = null;
				} else {
					this.handlerChange(this.selectedProducts);
				}
			},
		},
		donationAmount: {
			handler: debounce(async function (value) {
				this.selectedDonationProducts = [];

				if (value) {
					this.selectedDonationProducts = this.block.donation_products.map((product) => ({
						id: product.id,
						price: product.price,
						price_without_vat: product.price_without_vat,
						quantity: 1,
					}));
				} else {
					this.selectedDonationProducts = [];
				}

				await this.handlerChange(this.selectedProducts);
				// eslint-disable-next-line no-magic-numbers
			}, 300),
		},
	},
	created() {
		this.checkBlock();
	},
	mounted() {
		this.$store.dispatch('profile/getRoles');
	},
	methods: {
		checkBlock() {
			if (this.block.id === 35671695) {
				this.userCheckPassed = true;
			} else {
				this.userCheckPassed = false;
			}
		},
		setLoyaltyData(val) {
			this.loyaltyData = val;
		},
		async sendData(data) {
			if (this.block.products?.length) {
				if (!this.productsCountSum) {
					this.formErrors.push('Выберите минимум один билет');
					return;
				}
			}

			if (!this.isShowDonationErrors) {
				await this.handlerChange(this.selectedProducts);
				await this.submit();
			}
		},
		async handlerChange(selected) {
			this.selectedProducts = selected;
			this.productsCount = selected;

			await this.$api.getSumProducts({
				form_scenario_id: this.block.scenario_id,
				email: this.formValues.email,
				products: [...selected, ...this.selectedDonationProducts].map((el) => ({
					id: el.id,
					quantity: el.quantity,
					price: +el.price,
				})).filter((el) => !!el.quantity),
				promocode: this.isActivatePromocode ? this.promocode : null,
				donation_amount: this.donationAmount,
				needVerifyAlumni: this.formValues.needVerifyAlumni,
			}).then((res) => {
				this.priceWithPromocode = null;
				this.priceWithPromocodeWithoutDiscount = null;
				this.productsSumWithDiscount = res.sum;
				this.productsSum = res.sumWithoutDiscount;
				this.discountValue = res.discountValue;
				this.isVerifyAlumni = res.isVerifyAlumni;

				if (this.productsCountSum) this.formErrors = [];
			}).catch((error) => {
				const { data: { errors } } = error?.response;
				const { donation_amount: donationAmountErrors } = errors;
				if (donationAmountErrors?.length) this.showDonationError();
				this.isVerifyAlumni = false;
			});
		},
		handlerChangeChildsAge(value) {
			this.formValues.childsAge = value;
		},
		checkPromocodeLanding() {
			this.checkPromocode(this.block.products);
		},
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) {
				this.loyaltyProfile = data;
				const [currentLevel] = this.levels.filter((el) => el.id === this.loyaltyProfile.level.id);
				this.cardBackground = currentLevel.color;
			}
		},
		showDonationError() {
			this.donationError = `Введите корректную сумму пожертвования. Сумма должна быть до ${this.createMaskAmount(MAX_DONATION_AMOUNT)} рублей`;
			this.isShowDonationErrors = true;
		},
		validateDonationAmount(donation) {
			return Number.isNaN(donation) || (donation > MAX_DONATION_AMOUNT) || (donation < 1);
		},
		setAmount(amount) {
			this.donationAmount = amount;
			this.resetAmountButtons();

			this.amountButtonStates[amount] = true;

			this.isShowDonationErrors = false;
			const donationAmount = parseFloat(this.donationAmount);

			if (this.donationAmount && this.validateDonationAmount(donationAmount)) {
				this.showDonationError();
			}
		},
		getSelectedProducts() {
			return [...this.selectedProducts, ...this.selectedDonationProducts];
		},
		getUserData() {
			const userData = this.formValues;

			const data = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklAgreeSubscribeLookup: this.formValues.advertisingMailingsAgreement ? 'да' : 'нет',
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				...userData,
				...this.getAnalyticsData(),
				...{ can_return_vat_selected: +this.can_return_vat_selected },
			};

			if (this.donationAmount) {
				data.donation_amount = this.donationAmount;
			}

			return data;
		},
		getData() {
			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}
			this.setAgreementFields();

			return {
				user_data: this.getUserData(),
				products: this.getSelectedProducts(),
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
				loyalty_data: this.loyaltyData,
			};
		},
		onAmountInput() {
			if (!this.validateDonationAmount(this.donationAmount)) this.isShowDonationErrors = false;
			this.resetAmountButtons();
		},
		deleteDonation() {
			this.resetAmountButtons();
			this.donationAmount = '';
		},
		resetAmountButtons() {
			this.amountButtonStates['50000'] = false;
			this.amountButtonStates['10000'] = false;
			this.amountButtonStates['5000'] = false;
		},
		async handlerDiplomaChange(value) {
			if (this.formValues.needVerifyAlumni !== value) {
				this.$set(this.formValues, 'needVerifyAlumni', value);
				await this.handlerChange(this.selectedProducts);
			}
		},
	},
};
</script>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}

.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;

	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}

		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}

.error-message {
	color: red;
	font-size: 0.8rem;
}

.arrow-right {
	&--black {
		fill: black;
		padding: 0;
		cursor: pointer;
	}
}

.close {
	cursor: pointer;
	opacity: 1;
}

.close::before {
	content: '\e915';
	font-size: 1rem;
}

.amount_block {
	//height: 3rem;

	.original_amount {
		color: $border-color;
		font-weight: bold;
		text-decoration: line-through;
	}
}

.graduation-scenario__donation-input {
	height: calc(1.5em + 1.05rem + 2px) !important;
	border: 1px solid #949aba!important;
}
.graduation-scenario {
	&__donation-input-errors {
		color: #dc3545 !important;
		font-weight: 500 !important;
	}

	&__donation-input {
		height: calc(1.5em + 1.05rem + 2px) !important;
		border: 1px solid #949aba !important;
	}
}

.donate-info {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	padding: .3rem;
	border-radius: 50%;
	color: white;
	border: 1px solid $blue;
	background-color: $blue;
	font-size: .5rem;
}

.custom-form-error {
	&.formulate-form-errors {
		.formulate-form-error {
			color: $red;
			font-weight: 500;
		}
	}
}
</style>
